import type { JourneyPayload, OuterPayload, CartItemSummary } from '../../../types/analyticstypes';
import { formatMoney } from '../../../utils/analytics/format';
import CartItemRow from './CartItemRow';

export default function ItemsTab({
  journey,
  outer,
}: {
  journey: JourneyPayload;
  outer: OuterPayload;
}) {
  const cartItems = journey.cart?.items || [];
  const summaryByName: Record<string, CartItemSummary> = {};
  for (const c of cartItems) {
    if (c.name && !summaryByName[c.name]) summaryByName[c.name] = c;
  }

  const orders = outer.orders || [];
  const findSummary = (name: string) => {
    if (summaryByName[name]) return summaryByName[name];
    const lower = name.toLowerCase();
    for (const c of cartItems) {
      if (c.name?.toLowerCase() === lower) return c;
    }
    return undefined;
  };

  const currency = 'USD';

  if (orders.length === 0) {
    return (
      <div className="text-sm text-gray-500 italic p-6 text-center bg-gray-50 rounded-lg">
        No items recorded on this transaction.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between text-xs text-gray-500">
        <span>
          {orders.length} order line{orders.length !== 1 ? 's' : ''} · {outer.itemCount} item
          {outer.itemCount !== 1 ? 's' : ''}
        </span>
        <span className="font-mono font-medium text-gray-900">
          Total {formatMoney(outer.totalAmount, currency)}
        </span>
      </div>

      <div className="space-y-2">
        {orders.map((item, i) => (
          <CartItemRow
            key={item.guid ?? `${item.name}-${i}`}
            item={item}
            cartSummary={findSummary(item.name)}
            currency={currency}
          />
        ))}
      </div>
    </div>
  );
}
